import { expertInfo } from '@/apis/apiExpert.js';
import { getCourseByExpertId } from '@/apis/apiSchool.js';
import { useMutation } from '@tanstack/vue-query';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const useExpertsStore = defineStore(
  'storeExpert',
  () => {
    const vipCode = ref(''); // 邀请码
    const expertTypeEnum = ref([
      {
        label: '技术专家',
        id: 'technical',
      },
      {
        label: '业务专家',
        id: 'business',
      },
    ]);
    const expertTagsEnum = ref({ technical: [], business: [] });
    const userExpertInfo = ref({});

    const myCourseList = ref([]);

    // 获取课程
    const getCourseByExpertIdApi = async (id) => {
      const res = await getCourseByExpertId({ id });

      if (res) {
        myCourseList.value = res;
      }
    };

    // 获取专家信息
    const { mutate: expertInfoApi } = useMutation({
      mutationFn: expertInfo,
      onSuccess(val) {
        if (!val)
          return;
        userExpertInfo.value = val;

        if (val.id) {
          getCourseByExpertIdApi(val.id);
        }
      },
    });

    return {
      vipCode,
      expertTypeEnum,
      expertTagsEnum,
      userExpertInfo,
      expertInfoApi,
      myCourseList,
    };
  },
  {
    // 持久化
    persist: true,
  },
);

export default useExpertsStore;
